// extracted by mini-css-extract-plugin
export var table_cell = "content-module--table_cell--f7993";
export var table_foot = "content-module--table_foot--241a9";
export var table_graduated = "content-module--table_graduated--3d8d5";